<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
        <v-card-title>
            <span class="title">Synced Users ({{users.length}})
             </span>

          <v-spacer></v-spacer>
          <v-text-field append-icon="search" label="Quick Search" single-line hide-details v-model="search"></v-text-field>

          <v-spacer></v-spacer>
          <v-btn class="brown lighten-1" fab small dark @click.native="loadData()">
            <v-icon>refresh</v-icon>
          </v-btn>

        </v-card-title>
        <v-flex>
          <v-data-table
              :headers="headers"
              :search="search"
              :items="users"
          ><template slot="items" slot-scope="props">
            <tr>
              <td v-for="header in headers">
                {{ props.item[header.value] }}
              </td>
              <td class="text-xs-left">
                <v-btn class="cyan" fab small  @click.native="remove(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
   </v-container>
</template>
<script>
/* globals Store */
import Table from "@/components/Table.vue";
import SearchPanel from "@/components/SearchPanel.vue";


export default {
  components: {
  },
  data () {
    return {
      search: null,
      users: [],
      headers: [{ text: 'wpid', value: 'wpid' },
        { text: 'nickname', value: 'nickname' },
        { text: 'permissions', value: 'permissions' },
    { text: 'username', value: 'username' },
    { text: 'password', value: 'password' },
        { text: 'token', value: 'token' }]
    }
  },
  methods: {
    loadData(){
      this.$services.userlist.find({
      }).then((result) => {
        console.log('userlist fetch result', result)
        this.users = result

      })
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {

    this.$nextTick(() => {
      this.loadData()
    })
  }
}
</script>


